import { renderMainLeftCell, renderColSpanCell, renderMainRightCell, renderSectionHeader, renderRowGaps } from '../helpers';
import { textMain, textLeft, textRight, textCenter } from '../download-data-styles';
import format from '_shared_/plugins/format.js';

const $format = format.formatHelpers;

export const renderHistDistHeaderRow = consolidated => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell('Record Date');
  rowString += renderMainLeftCell('Calculated Date');
  rowString += renderMainLeftCell('Pay Date');
  if (consolidated) {
    rowString += renderColSpanCell('Income Dividend Regular and Special', `${textMain}${textLeft}`, 2);
  } else {
    rowString += renderMainLeftCell('Income Dividend Regular');
    rowString += renderMainLeftCell('Income Dividend Special');
  }
  rowString += renderMainLeftCell('Cap. Gains Long-Term');
  rowString += renderMainLeftCell('Cap. Gains Short-Term');
  rowString += renderMainLeftCell('Reinvest NAV');
  rowString += `</tr>`;
  return rowString;
};

export const renderHistDistDataRow = (distribution, consolidated) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(distribution.ExDate);
  rowString += renderMainLeftCell(distribution.ReinvestDate);
  rowString += renderMainLeftCell(distribution.CheckDate);
  if (consolidated) {
    const consolidatedAmount = $format.convertStringToNumber(distribution.RegularDividendAmount) + $format.convertStringToNumber(distribution.SpecialDividendAmount);
    rowString += renderColSpanCell($format.histDistPrice(consolidatedAmount), `${textMain}${textRight}`, 2);
  } else {
    rowString += renderMainRightCell($format.histDistPrice(Number(distribution.RegularDividendAmount)));
    rowString += renderMainRightCell($format.histDistPrice(Number(distribution.SpecialDividendAmount)));
  }
  rowString += renderMainRightCell($format.histDistPrice(distribution.LongTermCapitalGainsAmount));
  rowString += renderMainRightCell($format.histDistPrice(distribution.ShortTermCapitalGainsAmount));
  rowString += renderMainRightCell($format.histDistPrice(distribution.ReinvestPrice));
  rowString += `</tr>`;
  return rowString;
};

export const renderHistDistYearToDate = data => {
  const yearToDate = data.yearToDate && data.yearToDate[data.selectedYear] || {};
  let ytdString = ``;
  ytdString += `<tr>`;
  ytdString += renderColSpanCell(`${data.selectedYear} Year-to-Date:`, `${textMain}${textCenter}`, 3);
  ytdString += `</tr>`;
  ytdString += `<tr>`;
  ytdString += renderMainLeftCell('Dividends Subtotal:');
  ytdString += renderMainLeftCell('Cap Gains Subtotal:');
  ytdString += renderMainLeftCell('Total Distributions:');
  ytdString += `</tr>`;
  ytdString += `<tr>`;
  ytdString += renderMainRightCell($format.histDistPrice(yearToDate.YTDDividendsAmount));
  ytdString += renderMainRightCell($format.histDistPrice(yearToDate.YTDCapitalGainsAmount));
  ytdString += renderMainRightCell($format.histDistPrice(yearToDate.YTDTotalDistributionsAmount));
  ytdString += `</tr>`;
  return ytdString;
};

export const historicalDistributionsModule = data => {
  const consolidated = data.objective === 'ManagedRisk';
  let moduleString = ``;
  moduleString += renderSectionHeader('Historical Distributions');
  moduleString += renderRowGaps();
  moduleString += renderColSpanCell(data.selectedYear, `${textMain}${textCenter}`, 8);
  moduleString += renderHistDistHeaderRow(consolidated);
  if (data.distributions) {
    data.distributions.forEach(distribution => {
      moduleString += renderHistDistDataRow(distribution, consolidated);
    });
  } else {
    moduleString += `<tr>`;
    moduleString += renderMainLeftCell(`No data available for ${data.selectedYear}`);
    moduleString += `</tr>`;
  }
  moduleString += renderRowGaps();
  moduleString += renderHistDistYearToDate(data);
  moduleString += renderRowGaps(2);
  return moduleString;
};
